import { useEffect, useContext, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Utils from "../../Utils";
import moment from "moment";

const PhPhotoshootRequest = (props) => {
  const { id } = useParams();

  function formatDateYmd(dateString) {
    return new Date(dateString).toISOString().split("T")[0];
  }
  /* Scroll to top function on submit of form */
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const [photoshootDetails, setPhotoshootDetails] = useState({});
  const [guidelineDetails, setGuidelineDetails] = useState([]);
  const [hotelDetails, setHotelDetails] = useState([]);

  useEffect(() => {
    /* Getting Photoshoot Details */
    axios
      .get(Utils.apiUrl(`photoshoot/${id}`), Utils.apiHeaders())
      .then((res) => {
        console.log(res.data.hotel_id);
        /* Getting Hotel Details */
        axios
          .get(Utils.apiUrl(`hotel/${res.data.hotel_id}`), Utils.apiHeaders())
          .then((res) => {
            console.log(res);
            if (res.status == 200) {
              setHotelDetails(res.data);
            }
          })
          .catch((err) => {
            //callback(false, err.message);
          });

        if (res.status == 200) {
          console.log(res.data);
          res.data.date_from = res.data.date_from != null ? formatDateYmd(res.data.date_from) : "";
          res.data.date_to = res.data.date_to != null ? formatDateYmd(res.data.date_to) : "";
          res.data.delivery_date = res.data.delivery_date != null ? formatDateYmd(res.data.delivery_date) : "";
          res.data.recce_end = res.data.recce_end != null ? formatDateYmd(res.data.recce_end) : "";
          res.data.recce_start = res.data.recce_start != null ? formatDateYmd(res.data.recce_start) : "";
          res.data.lifestyle_date = res.data.lifestyle_date != null ? formatDateYmd(res.data.lifestyle_date) : "";
          res.data.styling_deck_date = res.data.styling_deck_date != null ? formatDateYmd(res.data.styling_deck_date) : "";
          res.data.bt_submission_date = res.data.bt_submission_date != null ? formatDateYmd(res.data.bt_submission_date) : "";
          res.data.notes = res.data.details;
          setPhotoshootDetails(res.data);
          /* Getting Hotel Details */
          axios
            .get(Utils.apiUrl(`hotel/${res.data.hotel_id}`), Utils.apiHeaders())
            .then((res) => {
              if (res.status == 200) {
                /* Getting Hotel Details */
                axios
                  .get(Utils.apiUrl(`brand/${res.data.brand_id}`), Utils.apiHeaders())
                  .then((res) => {
                    console.log(res);
                    if (res.status == 200) {
                      setGuidelineDetails(res.data);
                    }
                  })
                  .catch((err) => {
                    //callback(false, err.message);
                  });
              }
            })
            .catch((err) => {
              //callback(false, err.message);
            });
        }
      })
      .catch((err) => {
        //callback(false, err.message);
      });
  }, []);

  const [submitted, setSubmitted] = useState(false);

  const downloadAttachment = (id) => {
    axios
      .get(Utils.apiUrl(`photoshoot/attachment/${id}`), {
        responseType: "arraybuffer", // Important for binary data
        ...Utils.apiHeaders(),
      })
      .then((res) => {
        console.log(res.data);

        // Convert buffer data into file
        const bufferData = res.data;

        // Convert to Uint8Array
        const byteArray = new Uint8Array(bufferData);

        // Create a Blob (set correct MIME type from response headers)
        const blob = new Blob([byteArray], { type: res.headers["content-type"] || "application/octet-stream" });

        // Get filename from headers or default
        const contentDisposition = res.headers["content-disposition"];
        const filename = contentDisposition ? contentDisposition.split("filename=")[1]?.replace(/"/g, "") || `attachment_${id}` : `attachment_${id}`;

        // Create download link
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();

        // Cleanup
        URL.revokeObjectURL(url);
        document.body.removeChild(a);
      })
      .catch((err) => {
        console.error("Download failed:", err);
        alert("Failed to download attachment");
      });
  };

  const getNextWorkingDays = (date, days) => {
    let result = moment(date);
    let count = 0;

    while (count < days) {
      //result = result.add(1, "days");
      result = result.subtract(1, "days");
      // Skip Sunday (0) & Saturday (6)
      if (result.day() !== 0 && result.day() !== 6) {
        count++;
      }
    }

    return result;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    //setPhotoshootDetails((prev) => ({ ...prev, [name]: value }));
    setPhotoshootDetails((prev) => {
      let updated = { ...prev, [name]: value };

      // AUTO CALCULATE SUBMISSION DATE
      if (name === "delivery_date" && value) {
        const submissionDate = getNextWorkingDays(value, 7).format("YYYY-MM-DD");

        updated.bt_submission_date = submissionDate;
      }
      return updated;
    });
  };

  /* Err list for validation of form */
  var [succ, setSucc] = useState({ status: false, message: "" });
  var [err, setErr] = useState([]);

  const submitForm = (e) => {
    e.preventDefault();
    scrollToTop();
    const data = {
      id: id,
      title: e.target.title.value,
      date_from: e.target.date_from.value,
      date_to: e.target.date_to.value,
      lifestyle: e.target.lifestyle.value,
      architectural: e.target.architectural.value,
      hotel_type: e.target.hotel_type.value,
      recce_start: e.target.recce_start.value,
      recce_end: e.target.recce_end.value,
      lifestyle_date: e.target.lifestyle_date.value,
      styling_deck_date: e.target.styling_deck_date.value,
      notes: e.target.notes.value,
      bt_submission_date: e.target.bt_submission_date.value,
      delivery_date: e.target.delivery_date.value,
    };

    axios
      .put(Utils.apiUrl(`photoshoot/verify`), data, Utils.apiHeaders())
      .then((res) => {
        console.log(res.data);
        if (res.data.success == true) {
          setSubmitted(true);
          err = [];

          axios
            .put(Utils.apiUrl(`photoshoot/verify`), data, Utils.apiHeaders())
            .then((res) => {
              console.log(res.data);
              if (res.data.success == true) {
                setSubmitted(true);
                err = [];
              } else {
                err.push(res.message);
              }
            })
            .catch((err) => {
              //callback(false, err.message);
            });
        } else {
          err.push(res.message);
        }
      })
      .catch((err) => {
        //callback(false, err.message);
      });
    //setSubmitted(true);
  };

  const isRecceDisabled = ["converted", "refresh"].includes(photoshootDetails?.hotel_type);
  // ✅ ADD LOGS HERE
  console.log("hotel_type:", photoshootDetails?.hotel_type);
  console.log("isRecceDisabled:", isRecceDisabled);
  useEffect(() => {
    if (isRecceDisabled) {
      setPhotoshootDetails((prev) => ({
        ...prev,
        recce_start: "",
        recce_end: "",
      }));
    }
  }, [photoshootDetails.hotel_type]);

  return (
    <>
      <main className="container mx-auto px-6 py-8">
        <h1 className="text-2xl font-bold text-gray-800 mb-6">Photoshoot Requirement Form</h1>

        {/* When form is not submitted */}
        {submitted == false && (
          <>
            {/* For Error on submission */}
            {err.length > 0 && (
              <div
                className="bg-red-100 border border-red-400 text-red-700 px-4 py-2 text-sm rounded relative mb-4
             w-full max-w-2xl mx-auto"
                role="alert"
              >
                <ul>
                  {err.map((item, index) => (
                    <li key={index} className="block">
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            )}

            <form id="photoshootForm" action="ph-photoshoot-request-confirmation.html" method="post" onSubmit={submitForm}>
              {/* <!-- Hotel/Venue Name (Full Width) --> */}

              {hotelDetails != null && (
                <div className="form-section">
                  <h3 className="text-lg font-medium">{`${hotelDetails.marsha}_${guidelineDetails.abbr}_${hotelDetails.name}`}</h3>
                </div>
              )}

              {/* <!-- Two Column Layout --> */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                {/* <!-- LEFT COLUMN --> */}
                <div>
                  {/* <!-- Photoshoot Dates --> */}
                  <div className="form-section">
                    <div className="section-heading">
                      <i className="fas fa-calendar"></i>
                      Photoshoot Dates
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                      <div className="form-group">
                        <label className="form-label">Start Date</label>
                        <input
                          name="date_from"
                          id="date_from"
                          type="date"
                          className="form-input"
                          value={`${photoshootDetails.date_from}`}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label">End Date</label>
                        <input
                          name="date_to"
                          id="date_to"
                          type="date"
                          className="form-input"
                          value={`${photoshootDetails.date_to}`}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>

                  {/* <!-- Number of Photos --> */}
                  <div className="form-section">
                    <div className="section-heading">
                      <i className="fas fa-camera"></i>
                      Number of Photos Needed
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                      <div className="form-group">
                        <label className="form-label">Architectural</label>
                        <input
                          name="architectural"
                          id="architectural"
                          type="number"
                          className="form-input"
                          value={`${photoshootDetails.architectural}`}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Lifestyle</label>
                        <input
                          name="lifestyle"
                          id="lifestyle"
                          type="number"
                          className="form-input"
                          value={`${photoshootDetails.lifestyle}`}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>

                  {/* <!-- Type of Hotel --> */}
                  <div className="form-section">
                    <div className="section-heading">
                      <i className="fas fa-building"></i>
                      Type of Photography Project:
                    </div>
                    <div className="radio-group">
                      <div className="radio-item">
                        <input
                          name="hotel_type"
                          type="radio"
                          id="recce-new"
                          value="new"
                          checked={photoshootDetails.hotel_type === "new"}
                          onChange={handleChange}
                        />
                        <label for="recce-new">Pre-opening/New Build</label>
                        <span className="recce-tag">Recce submission required</span>
                      </div>
                      <div className="radio-item">
                        <input
                          name="hotel_type"
                          type="radio"
                          id="recce-established"
                          value="established"
                          checked={photoshootDetails.hotel_type === "established"}
                          onChange={handleChange}
                        />
                        <label for="recce-established">External Conversion</label>
                        <span className="recce-tag">Recce submission required</span>
                        <i className="fas fa-question-circle" title="External brand conversion to Marriott brand"></i>
                      </div>
                      <div className="radio-item">
                        <input
                          name="hotel_type"
                          type="radio"
                          id="recce-converted"
                          value="converted"
                          checked={photoshootDetails.hotel_type === "converted"}
                          onChange={handleChange}
                        />
                        <label for="recce-converted">Internal Conversion</label>
                        <span className="recce-tag">Recce not needed</span>
                        <i className="fas fa-question-circle" title="One Marriott brand converting to another Marriott brand" />
                      </div>

                      <div className="radio-item">
                        <input
                          name="hotel_type"
                          type="radio"
                          id="recce-refresh"
                          value="refresh"
                          checked={photoshootDetails.hotel_type === "refresh"}
                          onChange={handleChange}
                        />
                        <label for="recce-refresh">Renovation/Refresh/Update</label>
                        <span className="recce-tag">Recce not needed</span>
                        <i className="fas fa-question-circle" title="Established and Operating hotel" />
                      </div>
                    </div>
                  </div>

                  {/* <!-- Attachments --> */}
                  {false && (
                    <div className="form-section">
                      <div className="section-heading">
                        <i className="fas fa-paperclip"></i>
                        Attachments
                      </div>

                      <div className="form-group">
                        {/* Loop for attachments */}
                        {photoshootDetails.attachments != undefined &&
                          photoshootDetails.attachments.length > 0 &&
                          photoshootDetails.attachments.map((attachment, index) => (
                            <>
                              <div className="attachment-item" onClick={() => downloadAttachment(attachment.id)}>
                                <i className="fas fa-file-alt"></i>
                                <span>Document {index + 1}</span>
                              </div>
                            </>
                          ))}
                        {/* If no attachments uploaded */}
                        {photoshootDetails.attachments != undefined && photoshootDetails.attachments.length == 0 && (
                          <>
                            <div className="attachment-item">No attachments uploaded</div>
                          </>
                        )}
                      </div>
                    </div>
                  )}

                  {/* <!-- Requirement Description --> */}
                  <div className="form-section">
                    <div className="section-heading">
                      <i className="fas fa-align-left"></i>
                      Notes
                    </div>

                    <div className="form-group">
                      <label className="form-label">Enter notes here</label>
                      <textarea
                        name="notes"
                        id="notes"
                        className="form-textarea"
                        placeholder="Enter detailed notes of photoshoot..."
                        value={photoshootDetails.notes || photoshootDetails.details}
                        onChange={handleChange}
                      ></textarea>
                    </div>
                  </div>
                </div>

                {/* <!-- RIGHT COLUMN --> */}
                <div>
                  <div className="reccedetails">
                    {/* <!-- Recce Dates --> */}
                    <div className={`form-section ${isRecceDisabled ? "opacity-60 pointer-events-none" : ""}`}>
                      <div className="section-heading">
                        <i className="fas fa-map-marker-alt"></i>
                        Recce Dates
                      </div>

                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                        {isRecceDisabled && <div className="text-sm text-gray-500 mb-1">Recce not required for selected hotel type</div>}
                        {!isRecceDisabled && (
                          <>
                            <div className="form-group">
                              <label className="form-label">Start Date</label>

                              <input
                                name="recce_start"
                                id="recce_start"
                                type="date"
                                className={`form-input`}
                                value={photoshootDetails.recce_end || ""}
                                onChange={handleChange}
                              />
                            </div>
                            <div className="form-group">
                              <label className="form-label">End Date</label>
                              <input
                                name="recce_end"
                                id="recce_end"
                                type="date"
                                className={`form-input ${isRecceDisabled ? "bg-gray-200 text-gray-500 cursor-not-allowed" : ""}`}
                                value={`${photoshootDetails.recce_end || ""}`}
                                onChange={handleChange}
                              />
                            </div>
                          </>
                        )}
                      </div>

                      <div className="instruction-note">
                        <i className="fas fa-lightbulb mr-2"></i>
                        Dates for the Hotel to book the venue for Recce.
                      </div>
                    </div>
                  </div>

                  {/* <!-- Lifestyle Mood Board / Styling Deck Dates  --> */}
                  <div className="form-section">
                    <div className="section-heading">
                      <i className="fas fa-map-marker-alt"></i>
                      Lifestyle Mood Board / Styling Deck
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                      <div className="form-group">
                        <label className="form-label">Lifestyle Date</label>
                        <input
                          name="lifestyle_date"
                          id="lifestyle_date"
                          type="date"
                          className="form-input"
                          value={`${photoshootDetails.lifestyle_date || ""}`}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Styling Deck Date</label>
                        <input
                          name="styling_deck_date"
                          id="styling_deck_date"
                          type="date"
                          className="form-input"
                          value={`${photoshootDetails.styling_deck_date || ""}`}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="instruction-note">
                      <i className="fas fa-lightbulb mr-2"></i>
                      Dates for the Lifestyle Mood Board and Styling Deck.
                    </div>
                  </div>

                  {/* <!-- Delivery Dates --> */}
                  <div className="form-section">
                    <div className="section-heading">
                      <i className="fas fa-truck"></i>
                      Final Image Delivery to Hotel
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                      <div className="form-group">
                        <label className="form-label">Select Date</label>
                        <input
                          name="delivery_date"
                          id="delivery_date"
                          type="date"
                          className="form-input"
                          placeholder="Leave blank if not applicable"
                          value={`${photoshootDetails.delivery_date}`}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="instruction-note">
                      <i className="fas fa-lightbulb mr-2"></i>
                      This is the final date when the Hotel Rep. will have all the approved Final images
                    </div>
                  </div>
                  {/* <!-- Submission Dates --> */}
                  <div className="form-section">
                    <div className="section-heading">Brand Team Submission Date</div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                      <div className="form-group">
                        <label className="form-label">Select Date</label>
                        <input
                          name="bt_submission_date"
                          id="bt_submission_date"
                          type="date"
                          className="form-input"
                          placeholder="Leave blank if not applicable"
                          value={`${photoshootDetails.bt_submission_date}`}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="instruction-note">
                      <i className="fas fa-lightbulb mr-2"></i>
                      Min. 7 working days in adv. than the final date
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Action Button (Full Width) --> */}
              <div className="form-section text-right">
                <div className="form-group">
                  <button type="submit" className="btn-primary btn py-2 px-4 rounded">
                    <i className="fas fa-check-circle mr-2"></i>
                    Accept &amp; Verify
                  </button>
                </div>
              </div>
            </form>
          </>
        )}

        {/* When form is submitted */}
        {submitted == true && (
          <>
            <div className="confirmation-message text-center">
              <p className="text-lg text-green-600 mb-4">Photoshoot request has been submitted successfully.</p>
            </div>
            <div className="block bg-white shadow-md rounded-lg p-6 mb-6">
              <h2 className="text-xl font-bold mb-4">Guideline for Photographer</h2>
              <div className="mb-6" dangerouslySetInnerHTML={{ __html: guidelineDetails.ph_guidelines }}></div>
            </div>
          </>
        )}
      </main>
    </>
  );
};

export default PhPhotoshootRequest;
